import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, input, output } from "@angular/core";

@Component({
  selector: "service-tags",
  templateUrl: "service-tags.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AngularSvgIconModule],
})
export class ServiceTags {
  protected tags = input.required<string[]>();
  protected firewallEnabled = input.required<boolean>();

  /**
   * When true, tags render as clickable filter toggles (the subscriptions
   * page's checktag style) instead of static labels.
   */
  public readonly interactive = input(false);
  public readonly activeTags = input<string[]>([]);
  public readonly tagToggled = output<string>();

  protected isActive(tag: string): boolean {
    return this.activeTags().includes(tag);
  }
}
